(function() {
    'use strict';

    angular.module('file.constants', [])
        .constant('fileMessagesConst', {
            add: 'Dodano nowy plik!',
            update: 'Dane pliku zostały zaktualizowane!',
            delete: 'Plik został usunięty!',
            error: 'Wystąpił bład!'
        })
        .constant('filePermissionsConst', {
            view: {
                value: 'view_file',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu pliku!'
            },
            add: {
                value: 'add_file',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania pliku!'
            },
            update: {
                value: 'change_file',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji pliku!'
            },
            delete: {
                value: 'delete_file',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania pliku!'
            }
        })
        .constant('summernoteFileMessagesConst', {
            add: 'Dodano nowe zdjęcie',
            delete: 'Zdjęcie zostało usunięte',
            error: 'Wystąpił bład'
        });
})();
